"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getLinkAttributes = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var TooltipEntity_1 = __importDefault(require("../decorators/TooltipEntity"));
var wagtailConfig_1 = require("../../../config/wagtailConfig");
var LINK_ICON = react_1["default"].createElement(Icon_1["default"], { name: "link" });
var BROKEN_LINK_ICON = react_1["default"].createElement(Icon_1["default"], { name: "warning" });
var MAIL_ICON = react_1["default"].createElement(Icon_1["default"], { name: "mail" });
var getEmailAddress = function (mailto) { return mailto.replace('mailto:', '').split('?')[0]; };
var getPhoneNumber = function (tel) { return tel.replace('tel:', '').split('?')[0]; };
var getDomainName = function (url) { return url.replace(/(^\w+:|^)\/\//, '').split('/')[0]; };
// Determines how to display the link based on its type: page, mail, anchor or external.
exports.getLinkAttributes = function (data) {
    var url = data.url || null;
    var icon;
    var label;
    if (!url) {
        icon = BROKEN_LINK_ICON;
        label = wagtailConfig_1.STRINGS.BROKEN_LINK;
    }
    else if (data.id) {
        icon = LINK_ICON;
        label = url;
    }
    else if (url.startsWith('mailto:')) {
        icon = MAIL_ICON;
        label = getEmailAddress(url);
    }
    else if (url.startsWith('tel:')) {
        icon = LINK_ICON;
        label = getPhoneNumber(url);
    }
    else if (url.startsWith('#')) {
        icon = LINK_ICON;
        label = url;
    }
    else {
        icon = LINK_ICON;
        label = getDomainName(url);
    }
    return {
        url: url,
        icon: icon,
        label: label,
    };
};
/**
 * Represents a link within the editor's content.
 */
var Link = function (props) {
    var entityKey = props.entityKey, contentState = props.contentState;
    var data = contentState.getEntity(entityKey).getData();
    return (react_1["default"].createElement(TooltipEntity_1["default"], __assign({}, props, exports.getLinkAttributes(data))));
};
Link.propTypes = {
    entityKey: prop_types_1["default"].string.isRequired,
    contentState: prop_types_1["default"].object.isRequired,
};
exports["default"] = Link;
